import { DateTime } from "litepicker/dist/types/datetime";

export type DateRangeString = [string, string];
export type DisabledDateDefinition = DateRangeString | string | number;

export default class CalendarUtils {
  public static getEnabledDateBefore(
    date: DateTime,
    bookedDates: DateRangeString[],
    disabledDays: DisabledDateDefinition[]
  ): DateTime {
    const currentDate: DateTime = date.clone();
    // eslint-disable-next-line no-constant-condition
    while (true) {
      currentDate.subtract(1, "day");

      if (
        CalendarUtils.isDateAvailable(currentDate, bookedDates, disabledDays)
      ) {
        return currentDate;
      }
    }
  }

  public static getEnabledDateAfter(
    date: DateTime,
    bookedDates: DateRangeString[],
    disabledDays: DisabledDateDefinition[]
  ): DateTime {
    const currentDate: DateTime = date.clone();
    // eslint-disable-next-line no-constant-condition
    while (true) {
      currentDate.add(1, "day");

      if (
        CalendarUtils.isDateAvailable(currentDate, bookedDates, disabledDays)
      ) {
        return currentDate;
      }
    }
  }

  public static isDateAvailable(
    date: DateTime,
    bookedDates: DateRangeString[],
    disabledDays: DisabledDateDefinition[]
  ): boolean {
    // I was not able to use Litepicker utils, so I created my own testing logic
    for (const range of bookedDates) {
      if (
        date.isSame(new Date(range[0]) as any, "day") ||
        date.isBetween(
          new Date(range[0]) as any,
          new Date(range[1]) as any,
          "[]"
        )
      ) {
        return false;
      }
    }

    for (const definition of disabledDays) {
      switch (typeof definition) {
        case "string": // single date
          if (date.isSame(new Date(definition) as any)) {
            return false;
          }
          break;

        case "number": // day of week
          // eslint-disable-next-line no-case-declarations
          const normalizedDay = definition === 7 ? 0 : definition;
          if (date.getDay() === normalizedDay) {
            return false;
          }
          break;

        default:
          // date range
          if (
            date.isSame(new Date(definition[0]) as any, "day") ||
            date.isBetween(
              new Date(definition[0]) as any,
              new Date(definition[1]) as any,
              "()"
            )
          ) {
            return false;
          }
      }
    }

    return true;
  }
}
